import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, Button, Grid, LL_H_C, SimpleListAdapter, TS_DropDown, TS_PropRenderer, TS_Tabs } from '@nu-art/thunderstorm-frontend/index';
import { QScrollWrapper } from '@app/hcs-frontend';
import { Component_SwitchView } from '@nu-art/permissions-frontend/ui/Component_SwitchView';
import { DefaultEditor_InputText } from '@app/styles/frontend/ui-manager/ui-components';
import './Editor_Organization_Facilities.scss';
import { sortArray } from '@nu-art/ts-common';
import { TS_EditableItemComponentProto } from '@nu-art/thunderstorm-frontend/editable-item';
import { ModuleFE_AdvisorConfiguration } from '../../../../../_entity/instance/advisor-configuration/index.js';
import { ViewKey_Edit, ViewKey_View } from '../../../consts.js';
import { DropDown_Timezone } from '../../../../../_entity.js';
import { ModuleFE_NoteTemplate } from '@app/advisor-content-frontend';
export class Editor_Organization_Facilities extends TS_EditableItemComponentProto {
    // ######################## Lifecycle ########################
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.editMode = nextProps.editMode;
        // should show save button for a new Facility on edit mode
        state.showSave = state.editable && !state.editable?.item._id && state.editMode;
        return state;
    }
    // ######################## Logic ########################
    getViewMode = () => this.state.editMode ? ViewKey_Edit : ViewKey_View;
    getTabs = () => {
        return [{
                uid: 'facility-info',
                title: 'Facility Information',
                content: this.renderForm,
            }];
    };
    // ######################## Render ########################
    render() {
        return _jsx(LL_H_C, { id: 'editor-organization-facilities', children: this.renderTabs() });
    }
    // ######################## Render - All Tabs ########################
    renderTabs = () => {
        if (!this.state.editable)
            return;
        return _jsx(TS_Tabs, { tabs: this.getTabs() });
    };
    // ######################## Render - Facility Editor ########################
    renderForm = () => {
        if (!this.state.editable)
            return _jsx(_Fragment, {});
        const className = _className(this.state.editMode && 'edit-mode');
        return (_jsx("div", { className: "form-wrapper", children: _jsx("div", { className: "form-wrapper__left", children: _jsx(QScrollWrapper, { children: _jsxs(Grid, { className: className, children: [this.renderName(), this.renderConfiguration(), this.renderNoteTemplate(), this.renderTimezone(), this.renderSaveButton()] }) }) }) }));
    };
    renderSaveButton = () => {
        const editable = this.state.editable;
        const showSave = this.state.showSave;
        if (!showSave)
            return;
        return _jsxs(_Fragment, { children: [_jsx(Button, { variant: 'primary', disabled: !editable.item.advisorConfigurationId, onClick: async () => {
                        try {
                            await editable?.save();
                            this.setState({ showSave: false });
                        }
                        catch (err) {
                            this.logError(err);
                            this.forceUpdate();
                        }
                    }, children: "Save" }), _jsx("div", {})] });
    };
    renderConfiguration = () => {
        const configurations = ModuleFE_AdvisorConfiguration.cache.filter(config => config.organizationId === this.props.organizationId);
        const configurationsAdapter = SimpleListAdapter(sortArray(configurations), item => _jsx("div", { children: item.item.label }));
        const editable = this.state.editable;
        const selectedConfiguration = configurations.find(config => config._id === editable.item.advisorConfigurationId);
        return _jsx(TS_PropRenderer.Flat, { label: 'Configuration', children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                    {
                        key: ViewKey_View,
                        renderer: () => _jsx("div", { className: 'grid-data', children: selectedConfiguration?.label ?? '-' })
                    },
                    {
                        key: ViewKey_Edit,
                        renderer: () => _jsx(TS_DropDown, { adapter: configurationsAdapter, selected: selectedConfiguration, onSelected: async (selected) => {
                                this.state.editable?.updateObj({ advisorConfigurationId: selected._id });
                            } })
                    }
                ] }) });
    };
    renderNoteTemplate = () => {
        const noteTemplates = ModuleFE_NoteTemplate.cache.all();
        const noteTemplatesAdapter = SimpleListAdapter(sortArray([...noteTemplates], item => item.label), item => _jsx("div", { children: item.item.label }));
        const editable = this.state.editable;
        const selectedNoteTemplate = noteTemplates.find(template => template._id === editable.item.noteTemplateId);
        return _jsx(TS_PropRenderer.Flat, { label: 'Note Template', children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                    {
                        key: ViewKey_View,
                        renderer: () => _jsx("div", { className: 'grid-data', children: selectedNoteTemplate?.label ?? '-' })
                    },
                    {
                        key: ViewKey_Edit,
                        renderer: () => _jsx(TS_DropDown, { adapter: noteTemplatesAdapter, selected: selectedNoteTemplate, onSelected: async (selected) => {
                                this.state.editable?.updateObj({ noteTemplateId: selected._id });
                            } })
                    }
                ] }) });
    };
    renderTimezone = () => {
        const editable = this.state.editable;
        const selectedTimezone = editable.item.timezone;
        return _jsx(TS_PropRenderer.Flat, { label: 'Timezone', children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                    {
                        key: ViewKey_View,
                        renderer: () => _jsx("div", { className: 'grid-data', children: selectedTimezone ?? '-' })
                    },
                    {
                        key: ViewKey_Edit,
                        renderer: () => _jsx(DropDown_Timezone.selectable, { selected: selectedTimezone, onSelected: async (selected) => {
                                this.state.editable?.updateObj({ timezone: selected });
                            } })
                    }
                ] }) });
    };
    renderName = () => {
        const editable = this.state.editable;
        return _jsx(TS_PropRenderer.Flat, { label: 'Facility Name', error: editable?.hasError('name'), children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                    { key: ViewKey_View, renderer: () => _jsx("div", { className: 'grid-data', children: editable?.item.name }) },
                    {
                        key: ViewKey_Edit,
                        renderer: () => _jsx(DefaultEditor_InputText, { editable: editable, prop: 'name' })
                    }
                ] }) });
    };
}
//# sourceMappingURL=Editor_Organization_Facilities.js.map